import request from '@/utils/request'

// 员工名片群管理列表
export function employeeBusinessCardGroupList(params = {}) {
  return request({
    url: '/spWorkWechat/wwScript/businessGroupChat/index',
    method: 'get',
    params
  })
}

// 群列表（用于选择群）
export function businessGroupChatList(params = {}) {
  return request({
    url: '/spWorkWechat/wwScript/businessGroupChat/chatList',
    method: 'get',
    params
  })
}

// 企业列表（用于选择企业）
export function filterCorpList(params = {}) {
  return request({
    url: '/spWorkWechat/phoneRelation/filterCorp',
    method: 'get',
    params
  })
}

// 员工列表（用于选择员工）
export function spCorpcorpUsersList(params = {}) {
  return request({
    url: '/spWorkWechat/spCorp/corpUsersList',
    method: 'get',
    params
  })
}

// 新增员工名片群
export function employeeBusinessCardGroupCreate(data = {}) {
  return request({
    url: '/spWorkWechat/wwScript/businessGroupChat/create',
    method: 'post',
    data
  })
}

// 更新状态（开关）
export function employeeBusinessCardGroupUpdate(data = {}) {
  return request({
    url: '/spWorkWechat/wwScript/businessGroupChat/update',
    method: 'post',
    data
  })
}

